"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var easy_peasy_1 = require("easy-peasy");
var react_1 = __importStar(require("react"));
var i18nConfig_1 = require("../../helpers/i18nConfig");
var store_1 = __importDefault(require("../../store"));
var AppConfigInitializer_1 = __importDefault(require("../AppConfigInitializer"));
var AppHeader_1 = __importDefault(require("../AppHeader"));
var LayoutController_1 = __importDefault(require("../LayoutController"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
i18nConfig_1.initi18nConfig();
var AppContainer = function (props) {
    var models = props.models, header = props.header, appConfig = props.appConfig, children = props.children;
    react_1.useEffect(function () {
        if (appConfig && appConfig.translations)
            i18nConfig_1.setTranslations(appConfig.translations);
    }, [appConfig]);
    return (react_1.default.createElement(easy_peasy_1.StoreProvider, { store: store_1.default(models) },
        react_1.default.createElement(LayoutController_1.default, null),
        react_1.default.createElement(AppConfigInitializer_1.default, __assign({}, appConfig)),
        react_1.default.createElement(LocaleProvider_1.default, null,
            react_1.default.createElement(antd_1.Layout, { className: "ant-app-container", hasSider: false },
                Object.keys(header).length > 0 ? react_1.default.createElement(AppHeader_1.default, __assign({}, header)) : react_1.default.createElement(react_1.default.Fragment, null, " "),
                children))));
};
exports.default = AppContainer;
